module.exports = __webpack_public_path__ + "img/user-avatar-square.e49e0b46.svg";